export const Devices = {
  MOBILE: "mobile",
  TABLET: "table",
  LAPTOP: "laptop",
  DESKTOP: "desktop",
  UNKNOWN: "unknown", // SSR
};
